import Button from "../../Custom/Button/Button";
import "./chooseLockType.css";

const ChooseLockType = ({ setLockType }) => {
  return (
    <div className="unlock-screen">
      <div className="wrapper-choose-lock">
        <h6>Odaberite način otključavanja</h6>
        <div className="wrapper-choose">
          <div className="wrapper-choose-button" onClick={() => setLockType(1)}>
            <Button activation={true}>Šablon </Button>
          </div>
          <div className="wrapper-choose-button" onClick={() => setLockType(2)}>
            <Button activation={true}>Kod </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseLockType;
